/**
 * adminStyles.js — Shared styles for Admin Dashboard tabs
 * Extracted from AdminDashboard.js during Phase 1 refactor
 */

const S = {
  page: {
    minHeight: "100vh",
    backgroundColor: "#f8fafc",
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  },
  topBar: {
    backgroundColor: "#1e293b",
    color: "#fff",
    padding: "12px 24px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  topBarTitle: { fontSize: "16px", fontWeight: "700", margin: 0 },
  topBarUser: { fontSize: "12px", color: "#94a3b8" },
  signOutBtn: {
    background: "none",
    border: "1px solid #475569",
    color: "#94a3b8",
    borderRadius: "6px",
    padding: "4px 12px",
    fontSize: "12px",
    cursor: "pointer",
  },
  tabs: {
    display: "flex",
    backgroundColor: "#fff",
    borderBottom: "2px solid #e2e8f0",
    padding: "0 24px",
  },
  tab: {
    padding: "14px 20px",
    fontSize: "14px",
    fontWeight: "600",
    color: "#64748b",
    cursor: "pointer",
    borderBottom: "2px solid transparent",
    marginBottom: "-2px",
    transition: "all 0.2s",
    backgroundColor: "transparent",
    border: "none",
  },
  tabActive: {
    color: "#1E3A5F",
    backgroundColor: "#EFF6FF",
    borderBottom: "2px solid #3b82f6",
  },
  content: { padding: "24px", maxWidth: "1100px", margin: "0 auto" },
  card: {
    backgroundColor: "#fff",
    borderRadius: "12px",
    boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
    padding: "20px",
    marginBottom: "16px",
  },
  cardTitle: {
    fontSize: "16px",
    fontWeight: "700",
    color: "#1e293b",
    margin: "0 0 16px 0",
  },
  table: { width: "100%", borderCollapse: "collapse", fontSize: "13px" },
  th: {
    textAlign: "left",
    padding: "8px 12px",
    borderBottom: "2px solid #e2e8f0",
    color: "#64748b",
    fontWeight: "600",
    fontSize: "11px",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
  },
  td: {
    padding: "10px 12px",
    borderBottom: "1px solid #f1f5f9",
    color: "#334155",
  },
  badge: (color) => ({
    display: "inline-block",
    padding: "2px 8px",
    borderRadius: "10px",
    fontSize: "11px",
    fontWeight: "600",
    backgroundColor: `${color}15`,
    color: color,
  }),
  input: {
    padding: "8px 10px",
    border: "1px solid #e2e8f0",
    borderRadius: "6px",
    fontSize: "13px",
    outline: "none",
    width: "100%",
    boxSizing: "border-box",
  },
  btnPrimary: {
    padding: "8px 16px",
    backgroundColor: "#3b82f6",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    fontSize: "13px",
    fontWeight: "600",
    cursor: "pointer",
  },
  btnSecondary: {
    padding: "8px 16px",
    backgroundColor: "#fff",
    color: "#334155",
    border: "1px solid #e2e8f0",
    borderRadius: "6px",
    fontSize: "13px",
    fontWeight: "600",
    cursor: "pointer",
  },
  btnDanger: {
    padding: "6px 12px",
    backgroundColor: "#fee2e2",
    color: "#dc2626",
    border: "none",
    borderRadius: "6px",
    fontSize: "12px",
    fontWeight: "600",
    cursor: "pointer",
  },
  alertBanner: {
    backgroundColor: "#fef3c7",
    border: "1px solid #fbbf24",
    borderRadius: "8px",
    padding: "12px 16px",
    marginBottom: "16px",
    fontSize: "13px",
    color: "#92400e",
  },
  select: {
    padding: "8px 10px",
    border: "1px solid #e2e8f0",
    borderRadius: "6px",
    fontSize: "13px",
    outline: "none",
    backgroundColor: "#fff",
  },
  loginContainer: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#f8fafc",
  },
  loginCard: {
    backgroundColor: "#fff",
    borderRadius: "16px",
    boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
    padding: "40px 32px",
    maxWidth: "400px",
    width: "100%",
    textAlign: "center",
  },
  flexRow: { display: "flex", gap: "12px", alignItems: "center" },
  flexRowBetween: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "16px",
  },
  stockLevel: (qty, threshold) => ({
    fontWeight: "700",
    color:
      qty <= 0 ? "#dc2626" : qty <= (threshold || 0) ? "#f59e0b" : "#16a34a",
  }),
};

export default S;
